// extracted by mini-css-extract-plugin
export default {"login":"SsoSpPage_login_vkgNu","title":"SsoSpPage_title_acqGK","next_button_wrap":"SsoSpPage_next_button_wrap_eYJjV"};